import { render, staticRenderFns } from "./polaPrinciple.vue?vue&type=template&id=592b135b&scoped=true&"
import script from "./polaPrinciple.vue?vue&type=script&lang=js&"
export * from "./polaPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./polaPrinciple.vue?vue&type=style&index=0&id=592b135b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592b135b",
  null
  
)

export default component.exports